/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { esNumerico } from '@infotrack/utilitarios/expresionesRegulares';
import React from 'react';
import { IFormularioTipoSociedadVistaProps } from '../interfaces';
const FormularioTipoSociedadVista: React.FunctionComponent<IFormularioTipoSociedadVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    tipoSociedad,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tipoSociedad.agregarTipoSociedad'
                                : 'tipoSociedad.modificarTipoSociedad'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoSociedad.codigoTipoSociedad" display="inline" />}
                        name="CodigoTipoSociedad"
                        onChange={(e) => esNumerico(e.target.value, 8, false) && cambiarInfoFomulario(e)}
                        required
                        value={tipoSociedad.CodigoTipoSociedad}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoSociedad.nombreTipoSociedad" display="inline" />}
                        name="NombreTipoSociedad"
                        onChange={cambiarInfoFomulario}
                        required
                        value={tipoSociedad.NombreTipoSociedad}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox checked={tipoSociedad.EstadoTipoSociedad} onChange={cambiarInfoFomulario} />}
                        label={<Texto id="tipoSociedad.estadoTipoSociedad" display="inline" />}
                        name="EstadoTipoSociedad"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <div>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                            <Texto id="boton.cancelar" />
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={accionCrearEditar} color="primary" variant="contained">
                            <Texto id="boton.guardar" />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </DialogActions>
    </Dialog>
);

export default FormularioTipoSociedadVista;
